import { DateTime } from 'luxon';
import { useCallback, useEffect, useState } from 'react';

import {
  ListingApplicationMini,
  ListingApplicationType,
  fetchApplications,
} from 'api/ats';
import { Group } from 'api/groupAdmin';
import { Listing, Org } from 'api/orgAdmin';
import { Org as StaffOrg } from 'api/staff/orgs';
import { configValue } from 'utils/config';
import {
  NOTIFICATIONS,
  dismissNotification,
  getNotificationStatus,
  notificationIsDismissed,
  setNotificationStatus,
} from 'utils/localNotifications';
import * as localStorage from 'utils/localStorage';

type ApplicationSearch = (
  arg0: string,
  arg1: string | null | undefined,
  arg2: ListingApplicationType,
  arg3: number | null | undefined
) => {
  loading: boolean;
  applications: Array<ListingApplicationMini> | null | undefined;
  count: number | null | undefined;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  search: (...args: Array<any>) => any;
  searchIndex: number;
};
export const useApplicationSearch: ApplicationSearch = (
  orgId,
  listingId,
  listingType
) => {
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState();
  const [count, setCount] = useState();
  const [searchIndex, setSearchIndex] = useState(0);
  const search = useCallback(() => {
    const params = {
      id: listingId,
      type: listingType,
    };
    fetchApplications(orgId, params).then((response) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'listingApplications' does not exist on t... Remove this comment to see the full error message
      setApplications(response.listingApplications);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'count' does not exist on type 'unknown'.
      setCount(response.count);
      setSearchIndex((prev) => prev + 1);
      setLoading(false);
    });
  }, [listingId, listingType, orgId]);
  useEffect(() => {
    search();
  }, [listingId, listingType, orgId, search]);
  return {
    loading,
    applications,
    count,
    search,
    searchIndex,
  };
};
export const atsSurveyBannerIsDismissed = () =>
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  notificationIsDismissed(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER);
export const atsSurveyBannerShouldDisplay = () =>
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  getNotificationStatus(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER) === 'NEW';
export const dismissAtsSurveyBanner = () =>
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
  dismissNotification(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER);
export const showAtsSurveyBanner = () => {
  if (!atsSurveyBannerIsDismissed()) {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    setNotificationStatus(NOTIFICATIONS.ORG_ADMIN_ATS_SURVEY_BANNER, 'NEW');
  }
};
export const getDefaultApplyAckText = (
  org: Org | StaffOrg | Group,
  listing?: Listing
) => {
  const locale = (listing && listing.locale) || org.locale;
  const orgName: string =
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasOrgNameOverride' does not exist on ty... Remove this comment to see the full error message
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    listing && listing.hasOrgNameOverride && listing.orgNameOverride // @ts-expect-error ts-migrate(2339) FIXME: Property 'orgNameOverride' does not exist on type ... Remove this comment to see the full error message
      ? listing.orgNameOverride
      : org.name
      ? org.name
      : '';
  const showOrgName =
    (listing && !listing.isPostedAnonymously && orgName) || false;
  return {
    en: `<p>Your resume and application materials have been successfully submitted ${
      showOrgName ? `to ${orgName} ` : ''
    }for the listing below.</p><p>Best Regards,</p><p>The Idealist Community Support Team</p>`,
    es: `<p>Tu currículum y otros materiales para tu postulación se han enviado correctamente ${
      showOrgName ? `a ${orgName} ` : ''
    }para esta oportunidad.</p><p>Suerte,</p><p>El Equipo de Idealist en Español</p>`,
    pt: `<p>O seu currículo e material de inscrição foram submetidos com sucesso ${
      showOrgName ? `para ${orgName} ` : ''
    }para o anúncio abaixo.</p><p>Saudações,</p><p>Equipe de Suporte à Comunidade Idealista</p>`,
  }[locale];
};
const HAS_USED_ATS = 'hasUsedAts';
export const usedAts = () => localStorage.setItem(HAS_USED_ATS, true);
export const hasUsedAts = () => localStorage.getItem(HAS_USED_ATS);
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasLegacyStatuses = (listing: Record<string, any>) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line prefer-destructuring
  const firstPublished = listing.firstPublished;
  const newStatusStartDate = configValue(
    'idealist',
    'ats',
    'newStatusStartDate'
  );

  if (!(firstPublished && newStatusStartDate)) {
    return false;
  }

  const firstPublishedDT = DateTime.fromISO(firstPublished);
  const newStatusStartDateDT = DateTime.fromISO(newStatusStartDate);
  return firstPublishedDT < newStatusStartDateDT;
};
